import styled from 'styled-components';

export const SaveFilterBtnContainer = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 600px) {
    margin: 0 0 14px 0;
  }
`;

export const DescriptionBox = styled.div`
  display: flex;
  align-items: center;

  .check-icon {
    position: relative;
    top: -1px;
    margin-right: 5px;
  }
`;

export const Description = styled.span`
  color: #478cc8;
  font-size: 12px;
  border-bottom: 1px dashed;
  margin-left: 5px;
  cursor: pointer;

  &:hover {
    border-bottom: 1px solid;
    color: #3a7bbf;
  }

  .no-pointer {
    cursor: text;
  }
`;
